import { Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { ListComponent } from '../../shared/list/list.component';

@Component({
  selector: 'app-work-log-list',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./work-log-list.component.scss', '../../shared/base-list/base-list.component.scss']
})
export class WorkLogListComponent extends ListComponent implements OnInit {
  @Input() user_id: string;

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService,
    public route: ActivatedRoute,
    public router: Router
  ) {
    super(cookieService, activeModal, titleService, translator, service, route, router);
    this.entity = 'work_log';
    this.userField = 'user_id';
  }

  getBody() {
    const body = super.getBody();
    const query = body.query;
    if (this.user_id) {
      body.mode = 'user';
      if (query) {
        body.query = [query, 'and', ['user_id', '=', this.user_id]];
      } else {
        body.query = ['user_id', '=', this.user_id];
      }
      this.columns = this.columns.filter(c => !['account_id', 'user_id'].includes(c.name));
    } else if (this.selectedAccount) {
      if (query) {
        body.query = [query, 'and', ['account_id', '=', this.selectedAccount]];
      } else {
        body.query = ['account_id', '=', this.selectedAccount];
      }
    }

    return body;
  }

  rowDoubleClick(e) {
    if (!this.user_id) {
      super.rowDoubleClick(e);
    }
  }

}
